import styled from 'styled-components';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export const StyledSelect = styled(Select)`
  && {
    min-width: ${({ theme }) => theme.noodera.spacing.x2};
    border: none;
    border-bottom: 2px solid ${({ theme }) => theme.palette.primary.forty};
    color: ${({ theme }) => theme.palette.primary.hundred};
    ${({ theme }) => theme.noodera.fontTypes.font5};

    &:before,
    &:after {
      display: none;
    }

    .MuiSelect-select {
      &:focus {
        background-color: transparent;
      }
    }

    svg {
      color: ${({ theme }) => theme.palette.primary.hundred};
      right: 0;
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    ${({ theme }) => theme.noodera.fontTypes.font5};
    min-height: 36px;
  }
`;
